import { Select } from 'antd'
import React, { FC } from 'react'
import { OptionType } from '../../../app/utils/constants/Options';
import './SelectInput.scss'
import { IoMdInformationCircleOutline } from 'react-icons/io';
const { Option } = Select;

interface SelectInputProps {
    label: string
    value: any;
    onChange: (value: number | string) => void;
    options: OptionType[];
    info?: string;
    ShowInfo?: boolean;
    classNameInfo?: string;
    dropdownStyle?: any;
    optionStyle?: any;
    mode?: any;
    setMenuOpen?: (data: boolean) => void
    setCompanyOpen?: (data: boolean) => void
    placeholder?: string
    /** Stops iOS Safari from scrolling the page when scrolling the dropdown list */
    popupClassName?: string
}

const SelectInput: FC<SelectInputProps> = (props) => {
    const { value, onChange, options, label, info, ShowInfo, classNameInfo, dropdownStyle, optionStyle, mode, placeholder, setMenuOpen, setCompanyOpen, popupClassName = 'select-dropdown-scroll-isolate' } = props
    return (
        <div>
            <div className='input-instruct'>
                <div className='input-label'>{label}</div>
                {ShowInfo && <div className="get-help-addOn-hover">
                    <div className="help-image-logo" > <IoMdInformationCircleOutline cursor='pointer' /></div>
                    <div className={classNameInfo}>{info}</div>
                </div>}
            </div>
            <Select
                value={value}
                onChange={onChange}
                style={{ width: '100%' }}
                dropdownStyle={dropdownStyle}
                popupClassName={popupClassName}
                mode={mode === "multiple" ? mode : ""}
                placeholder={placeholder}
                showSearch={false}
                onDropdownVisibleChange={(data: boolean) => {
                    if (setMenuOpen) {
                        setMenuOpen(data);
                    }
                    if (setCompanyOpen) {
                        setCompanyOpen(data);
                    }
                }}
            >
                {options.map(option => (
                    <Option key={option.value} value={option.value} style={optionStyle}>
                        {option.label}
                    </Option>
                ))}
            </Select>
        </div>
    )
}

export default SelectInput